exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-form-field__media-link .text-field-resizable[data-v-5ff41ade] {\n  margin: 0 0 32px;\n}\n.media-form-field__media-link .text-field-resizable[data-v-5ff41ade]:last-child {\n  margin: 0 0 8px;\n}\n", ""]);

// exports
